var _a;
import { jsx } from "react/jsx-runtime";
import "react";
import { useResizeDetector } from "react-resize-detector";
import useSizeDetector from "./useSizeDetector.esm.js";
const supportsResizeObserver = Boolean((_a = global.window) == null ? void 0 : _a.ResizeObserver);
const useResizeDetectorOrJustFakeIt = supportsResizeObserver ? useResizeDetector : useSizeDetector;
const withDimensions = (Component, {
  defaultWidth,
  defaultHeight
} = {}) => function WithDimensions(props) {
  const {
    width,
    height,
    ref
  } = useResizeDetectorOrJustFakeIt({
    refreshMode: "debounce",
    refreshRate: 250
  });
  const shouldRenderComponent = defaultWidth || defaultHeight || width || height;
  return /* @__PURE__ */ jsx("div", { style: {
    width: "100%",
    height: "100%"
  }, ref, children: shouldRenderComponent && /* @__PURE__ */ jsx(Component, { ...props, containerWidth: width ?? defaultWidth, containerHeight: height ?? defaultHeight }) });
};
export {
  withDimensions as default
};
